module.exports = __webpack_public_path__ + "static/media/Internationalpic3@2x.b9e551d7.png";